export default __webpack_public_path__ + "static/apple-icon-180x180-d2eaad89c8a54a4537222681a7fb8164.png";